module.exports = __webpack_public_path__ + "img/logo.485a8ea5.svg";